import React from "react";
import NuevaEtiqueta from "./Actions/NuevaEtiqueta";
//import FilterEtiqueta from './Actions/FilterEtiqueta'
import { Box, Stack } from "@mui/material";
import TiposContactoTable from "./Table/Table";
import { OBTENER_ETIQUETAS } from "./graphql/queries";
import { useQuery } from "@apollo/client";
import { MainContext } from "../../../../Context/MainCtx";

export default function EtiquetasContacto() {
  const { tokenDecoded } = React.useContext(MainContext);

  const etiquetaQuery = useQuery(OBTENER_ETIQUETAS, {
    variables: {
      idEmpresa: tokenDecoded ? tokenDecoded.idEmpresa : "",
    },
    fetchPolicy: "network-only",
  });

  return (
    <Box>
      <Stack
        direction="row"
        spacing={1}
        justifyContent="flex-end"
        alignItems="center"
        sx={{ mb: 1, position: { sm: "absolute" }, top: 60, right: 24 }}
      >
        <NuevaEtiqueta refetch={etiquetaQuery.refetch} />
      </Stack>
      <TiposContactoTable etiquetaQuery={etiquetaQuery} />
    </Box>
  );
}
